<template>
	<v-container 
		fluid 
		class = "pa-1"
	>		
		<v-card 
			outlined
		>
			<v-card-title
				class = "pb-0 pa-0 secondary body-1 white--text"
			>
				
				<!-- <v-btn
					x-small
					dense
					@click="actions(
						{ 
							option: 'setting_devices',
							name: 'setting_device'
						})"
				> -->
				<v-icon 
					small 
					color  = "white"
					class  = "ml-1 mr-2"
					@click = "$router.back()"
				>
					mdi-arrow-left-circle
				</v-icon>

				<v-spacer></v-spacer>
					
				<v-icon 
					small					
					icon
					v-text = "'mdi-cog'"	
					color  = "white"	
					class  = "mx-1"				
				></v-icon>
				<!-- </v-btn> -->
							
				<span
					class  = "ml-2" 
					v-text = "'Settings'"
				>
				</span>

				<!-- <strong 
					class="primary--text mx-2 body-1"
				>
					Device: 
				</strong> 
				<span> 
					{{ inf.name }} 
				</span>

				<strong
					class="info--text ml-2 mr-2 body-1"
				>
					Type: 				
				</strong>
				<span 
					class="body-1"
				>
					{{ inf.type }}
				</span> -->
				<v-spacer></v-spacer>
			
				<!-- <v-btn
					x-small
					class="mr-2 px-0"
					color="primary"
				>
						
					<v-icon 
						small 
						color="white"
						
						@click="$router.push('device')"
					>mdi-video-plus</v-icon>
	
				</v-btn> -->

				

			
			</v-card-title>				

		</v-card>	
				<grid-layout 
					:layout.sync				= "layout"
          :margin 						= "[0, 0]"			            
          :col-num 						= "120"
          :row-height 				= "20"
          :is-draggable 			= "grid_options.draggable"
          :is-resizable 			= "grid_options.resizable"
          :vertical-compact 	= "grid_options.vertical_compact"
          :prevent-collision 	= "grid_options.prevent_collision"
          :use-css-transforms = "true"
          :responsive 				= "grid_options.responsive"

    		>
		    	<grid-item 
		    		v-for 					 = "item in layout"                  
           	:x 							 = "item.x"
           	:y 							 = "item.y"
           	:w 							 = "item.w"
           	:h 							 = "item.h"
           	:i 							 = "item.i"
           	:minH   				 = "item.minH"
           	:minW   				 = "item.minW"
           	:key 						 = "item.i"
           	drag-allow-from  = ".vue-draggable-handle"
	         	drag-ignore-from = ".no-drag"
		      >
		               <!-- @moved="movedEvent" -->


						<component 
							:is 								= "item.component" 
							:key 								= "item.i + 50"
							v-if 								= "item.component!=='cam' && item.component !== 'settings'"
							:layout 						= "item.h" 
							:layout_id					= "item.Id"
							:hosts 							= "item.component === 'relay_status' ? item.stream_data : item.stream_data"
							:edit								= "false"
							:is_event						= "false"
							:selected_category 	= "item.sel_categactionsory"
							:info_logs					= "item.stream_data"
							:info_device 				= "item.component === 'relay_status' ? (item.stream_data || {}) : (item.stream_data && item.stream_data.info_cam ? item.stream_data.info_cam : (item.stream_data || {}))"
							:host_from 					= "item.stream_data && item.stream_data.deviceId ? item.stream_data.deviceId : ''"
							:info_to_device			= "item.stream_data" 
							:ref_to_component		= "item.ref_component"
							@recive_analytics 	= "actions($event)"
						></component>
						<!-- inf_dev -->
							<!-- v-on:close_component="del_draw($event)" -->
						<component 
							v-else-if			= "item.stream_data"
							:is						= "item.component" 
							:id_stream		= "item.stream_data.stream"
							:host					= "item.stream_data.host"
							:hostname			= "item.stream_data.hostname"
							:show_host		= "item.stream_data.show_host_id"
							:name					= "item.stream_data.name"
							:type					= "item.stream_data.type"
							:layout_id 		= "item.Id"
							:host_ip 			= "item.stream_data.ip"
							:info_stream  = "item.stream_data.info_cam"
							:is_analytic 	= "item.stream_data.sel_analytic"
							
						></component>
							<!-- v-on:to_streaming="change_stream_type($event)" -->
							<!-- v-on:close_component="del_draw($event)" -->
		        	</grid-item>
		    	</grid-layout>						
	</v-container>
</template>
<style scoped>
	.vue-draggable-handle{
		cursor: move;
	}

  .vue-grid-item>>>.vue-resizable-handle{ /* /deep/ */
    background-color: #9c8888; /* white #047dc3*/
   /* filter: grayscale(100%);*/ 
    /*filter: invert(100%);*/
    opacity:0.5;
    width:10px;
    height: 10px;
    /*filter: brightness(0.5);*/
   filter: hue-rotate(180deg); 
    /*filter: opacity(50%); */
  }
</style>
<script>

	import cam 							from '@/components/cam_test.vue' //'@/components/cam.vue'
	import events 					from '@/components/events/events.vue'
	import analytics 				from '@/components/analytics/analytics.vue'
	import axios 						from 'axios'
	import analytics_logs 	from '@/components/analytics/analytics_logs.vue'
	import VueGridLayout 		from 'vue-grid-layout'	
	import setting_stream 	from '@/components/stream/setting_stream.vue'
	import profile_list 		from '@/components/stream/profile_list.json'
	import EventBus 				from '@/event-bus'
	import device 					from '@/components/stream/device.vue'
	import relay_status 		from '@/components/stream/relay_status.vue'
	
	
	

	export default{
		name 			 : 'setting_device',
		components : {
			cam,
			events,
			analytics,
			analytics_logs,
			GridLayout : VueGridLayout.GridLayout,
     	GridItem   : VueGridLayout.GridItem, 		
     	setting_stream,	
     	device,
     	relay_status,
			
		},
		props 		: [],
		data 			: () => ({
			dialog 				: false,
			dialog_device : false,
			
			inf 					: {
				name : 'My Cam',
				type : 'IP',
			},
			inf_to_fields : {
				
			},
			setting_local : {}, // info local / device
			inf_dev 			: {},
			grid_options 	: {
				draggable 				: false,
				resizable 				: false,
				vertical_compact 	: true,
				prevent_collision : true,
				responsive 				: false,
			},
			layout 							: [], 
			position_x 					: 0,
			position_y 					: 0,
			select_analytic_cam : '', 
			inf_analytic 				: {},
		}), // data

		created(){
			if (localStorage.getItem('settings_device')) {
				let setting_dev = {};
				setting_dev = JSON.parse(localStorage.getItem('settings_device'));
				if (setting_dev && setting_dev.inf_setting) {

					this.setting_local = setting_dev.inf_setting;
					this.inf.name = setting_dev.inf_setting.name;
					this.get_list();
				}
			}else{
				console.warn("not found of setting device")
			}
		

		}, // created

		methods:{

			get_list(){
				const ID  = this.setting_local.id;

				axios.defaults.withCredential = false;
				const api = this.$URL + '/api/v1/device/' + ID;
				axios.get(api).then( res  => {
					let item = res.data;
					// console.log(res.data, 'Res get device item')
					this.inf_dev = item;
					this.render_layout(item);					
					this.$store.commit("Devices/update", item);

					
				}).catch( er => {
					console.log(er, 'Error get Device');
					this.inf_dev = this.setting_local;
					this.render_layout(this.setting_local);					
				})
			}, // get list

	

			actions(act){
				/*
					act: {
						option: ''.
						name: ''
					}
				*/
				let vm = this;
				if (act.option == 'start') {
					this.select_analytic_cam = act.name;
					this.render_cam_analytic(act.name);
				}
				if (act.option == 'stop') {
					// TODO: Implementar acción stop
				}

				if (act.option == 'restart') {
					// TODO: Implementar acción restart
				}
				if (act.option == 'render_analytic') {
					this.setting_local.container.push(act.info);
					vm.layout.some((lay) => {
						if (lay.component == 'analytics') {
							lay.stream_data.info_cam = act.info; 
							return true;
						}
						return false;
					})
				}
					

			}, // actions

			check_length(val){
					let layouts=this.layout;
					let num=0, sw=false, indx=0;
					for (let j = 0; j < layouts.length; j++) {
						if (layouts[j].i==val) {
							sw=true;
							// indx=layouts[j].i;
						}
						if (layouts[j].i>=indx) { // max value
							indx=layouts[j].i;
						}
					}
					if(sw){
						num=indx+1//layouts[layouts.length-1].i+1;
					}else{
						num=val;
					}
					return num;
					// this.layout[indx].i=num;
			}, // check lenght 


			add_draw(component, data, from){
				let draw=[]; 
				let len_dash=this.layout.length+1, 
					stream_data=[],
					len=0, 
					x=0, 
					y=0, 
					w=20, 
					h=10, 
					min_h=10, 
					min_w=20,
					ref = '';
				// console.log(component, from, 'draw');	
				// console.log(len, len_dash, 'length 1')
				//Component size defaults
				if (component=='events'){
					w 		= 45;
					h 		= 15;
					min_h = 15;// 26
					min_w = 45;
					x 		= 30;
					y 		= 0;
					stream_data = data;
					if (from == 'peripherals') {
						ref = from;
						x 	= 0
					}else{

						ref = 'motion';
					}

				}else if (component=='analytics') {
					w 					= 64;
					h 					= 15;
					min_h 			= 12;//19
					min_w 			= 64;
					x 					= 0;
					y 					= 16;
					stream_data = data;
				}else if(component=='analytics_logs'){
					w 					= 56;
					h 					= 15;
					min_h 			= 12; //17
					min_w 			= 52;
					// console.log(data, 'info to componet logs')
					stream_data = data;
					x 					= 64;
					y 					= 15;
				}else if(component=='device') {
					w 					= 45;
					h 					= 15;
					min_h 			= 15;
					min_w 			= 20;
					x 					= 75;
					y 					= 0;
					stream_data = data;
					if (from == 'peripherals') {
						x = 45;
					}
				}else if(component=='relay_status') {
					w 					= 100;
					h 					= 20;
					min_h 			= 15;
					min_w 			= 40;
					x 					= 0;
					y 					= 15;
					stream_data = data;
				}else{
					w 		= 30;
					h 		= 15;
					min_h = 8;
					min_w = 15;
				}

				h = (this.$vuetify.breakpoint.height * 0.02137);

				// Components streams
				if (component == 'cam') {
					x = 0;
					y = 0;
					if (from == 'udp' || from == 'event' ) {						
						// console.log(data, 'info to componet cam')
						stream_data = data;
						/*{
							host: this.$localhost+':4550/',
							host_id: data.deviceId,
							hostname: data.name,
							name: "dashboard",
							type: "udp",
							info_cam: data, 
							// ip: data.ip
						};*/
					}else{
						let dt = '', id_host = '';
						if(data.host){
							dt 			= data.host.name;
							id_host = data.host.id;
						}

						stream_data = {
							host 		 			: data.rtsp_stream,
							host_id  			: data.id,
							hostname 			: dt,
							name 					: "dashboard",
							type 					: "flv",
							ip 						: data.ip,
							show_host_id 	: id_host,
							info_cam 			: data,
							
						};
					}
				}

				// check spaces in layout
				// for (var i = 0; i < layout_items.length; i++) {

					//layout_items[len_dash].w+layout_items[len_dash].x;
					/*if (component=='cam') {

						x=this.position_x;
						y=this.position_y;
						if (x<=120) {
							x=this.position_x;
							this.position_x=x+w;
							// y=this.position_y;
							// this.position_y=layout_items[len_dash-1].w + y;
						}
						
						if (x>=120) {
							x=0;
							y=h+this.position_y; //layout_items[len_dash-1].
							this.position_y=y;
							this.position_x=x+w;
						}
					}else{

						// this.check_position_y();
						x=this.position_x;
						y=this.position_y;
						// console.log(x, y, w, h, 'componets else')
						if (x>=80) {
							x=0;
							y=h;
							this.position_y=y;
							this.position_x=x;

						}
						this.position_y=y;
						this.position_x=w;							
						
					}*/
						// console.log(x, w, x+w, 'position x')
					// if (x>120){ // || (x>90 && w>30) || x+w>120 
					// 	x=0;						
					// 	y=layout_items[len_dash].h;
					// 	console.log('break')

					// }
					
				// }
				// console.log(len, len_dash, 'length 2')
				
				len=len_dash;
				// x, y, w, h ya están establecidos arriba según el componente
			
				// console.log(len, len_dash, 'length 3')
				// console.log(x, y, 'x, y ')
				if(!stream_data){
					stream_data=null;
				}
				len=this.check_length(len);
				// console.log(len, 'length 4')
				draw={
					x: x,
					y: y,
					w: w,
					h: h,
					i: len,
					Id: len+component,
					state: true,
					minW: min_w,
            		minH: min_h,
					component: component,
					'stream_data': stream_data,
					ref_component: ref,
				}
				
				this.layout.push(draw);
					
			
					// console.log("this.layout", this.layout);
					// console.log("draw", draw);

			}, // add_draw

			render_layout(item){
				let stream = {
					stream : item.deviceId,
					hostname : item.name,
					type : "event",
					name : "setting_dev",
					info_cam : item,
					sel_analytic: 'motion'
				}
				let info_logs = item
				if (item) {
					if (item.type == 'PERIPHERAL') {

						this.add_draw('events', info_logs, 'peripherals');
						this.add_draw('device', this.inf_dev, 'peripherals'); // update
						
						// Agregar componente relay_status si es iot_relay
						if (item.type_peripheral === 'iot_relay') {
							this.add_draw('relay_status', {
								info_cam: item,
								serial: item.serial,
								ip: item.ip,
								deviceId: item.deviceId
							}, 'peripherals');
						}

					}else{
						this.add_draw('cam', stream, 'udp'); // update / info_cam
						this.add_draw('analytics', stream);  // update / info_cam
						this.add_draw('analytics_logs', info_logs);
						this.add_draw('events', info_logs);
						this.add_draw('device', this.inf_dev); // update

					} 

				}
			}, // render layout

			render_profile(opt){
				let list_temp = this.layout,
					temp_profile = profile_list[opt],
					vl = this,
					sw = false;
					// console.log(opt, "************************* Profile *****************")

				
					const temp = list_temp.some( function(layt1){
						if (layt1.component == 'events' && opt !== 'profile_1') {
							return true
						}
						return false;
					})
					sw = temp;

					list_temp.forEach( function(layt, idx_layt ){
						if (opt == 'profile_1' && layt.component == 'events') {
							list_temp.splice(idx_layt)
							
						}
					
						temp_profile.some( function (profl){
							// console.log(layt.component,' ==' ,profl.component, 'list equal ');
							if (profl.component == layt.component) {
			

								layt.x = profl.x;
								layt.y = profl.y;
								layt.w = profl.w;
								layt.h = profl.h;

								return true;
							} 
							if (profl.component ==  'events' && opt !== 'profile_1' && !sw ) {
								// console.log('render events 2')
								let temp_len = vl.check_length(list_temp.length);
								list_temp.push(
								{
									component : profl.component,
									i: temp_len,
									Id: temp_len+profl.component,
									state: true,
									minW: 49,
				            		minH: 15,	
									x : profl.x,
									y : profl.y,
									w : profl.w,
									h : profl.h,								
								})
								sw = true;
								return true;
							}
							return false;
						}) // some
					})// forEach
					this.layout = list_temp;
					/*if (component=='events') {
		w=79;
		h=15;
		x=40;
		y=0;
	}else if (component=='analytics') {
		w=64;
		h=15;
		x=0;
		y=16;
	}else if(component=='analytics_logs'){
		w=56;
		h=15;
		x=64;
		y=15;
	}else if(component=='settings') {*/
				// list_temp
			}, // render profile

			render_cam_analytic(opt){
				let temp = this.layout,
					vt = this;
					console.log('cam render ', opt )
				const find = temp.some( function (item_temp, idx_temp){
					if (item_temp.component == 'cam')  {
						// console.log('itemmmmmmmmmm' ,item_temp)
						vt.layout[idx_temp].stream_data.sel_analytic = opt;
						return true
					}
				})
				console.log(find, 'change cam option analytics')
			}, //render_cam_analytic
		
		}, // methods

		computed: {
			render_sel_analytic: function (){
				let sel = this.select_analytic_cam;
				console.log(sel, 'change play analytics')
				return sel;
			}
		}, // computed

		mounted(){
			let vm = this;
			/*const time_layout = setTimeout( () => {
				if (vm.layout && vm.layout.length == 0) {
					let info_temp = vm.setting_local;
					
					// if (vm.inf_dev) {
					// 	info_temp = vm.inf_dev 
					// }
					vm.render_layout(info_temp);
				}
				clearTimeout(time_layout);
			}, 1000);*/
			

			EventBus.$on('profile', (action) =>{				
				this.render_profile('profile_'+action)
			})

			EventBus.$on('drawable_setting_device', (actions)=>{ 

				 this.grid_options[actions.option]=actions.active;
			    // console.log('option draggable', actions );
			});

			EventBus.$on('update_device_to_comp', (action) => {
				if (action) {
					if (vm.layout && vm.layout.length > 0) {

						vm.layout.some((lay) => {
							if (lay.component == 'cam') {
									if (lay.stream_data) {
										lay.stream_data.hostname = action.name; 
									}
									return true;
							}
							return false;
						})
					}else{
						console.wanr("layout lenght no found setting device");
					}
				}
			});

		}, // mounted
	};
</script>